// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 384) return "static/chunks/384.fe5752fc684dd0a0.js";
	if (chunkId === 788) return "static/chunks/788.32d7fd64f33191f7.js";
	if (chunkId === 496) return "static/chunks/graphql-print.83edc8afc0370428.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"167":"52ceb51901841c11","225":"57671f315ae3f6d7","484":"26ab3b93c2bfa1d9","767":"3c46c5b06637e828"}[chunkId] + ".js";
};